var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},_vm._l((_vm.menu),function(item){return _c('a',{key:item.title,staticClass:"item",attrs:{"href":item.link}},[_c('span',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('img',{attrs:{"src":"/static/ic_arrow_right.png"}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41ababd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpCenter.vue
// module id = null
// module chunks = 